import { render, staticRenderFns } from "./PageFive.vue?vue&type=template&id=29d10a25&scoped=true"
import script from "./PageFive.vue?vue&type=script&lang=js"
export * from "./PageFive.vue?vue&type=script&lang=js"
import style0 from "./PageFive.vue?vue&type=style&index=0&id=29d10a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d10a25",
  null
  
)

export default component.exports